<template>
  <div>

    <div class="absolute top-0 left-0 text-white w-full topnav flex justify-between items-center">
      <div class="p-3">
        <router-link to="/">O3D-GEN2</router-link>
      </div>

      <div class="p-3">
        <div class="hidden lg:block">
          <router-link class="mx-2" to="/demo" exact-active-class="underline">Demos</router-link>
          <router-link class="mx-2" to="/docs" exact-active-class="underline">Documentation</router-link>
          <a class="inline mx-3 my-5" target="_blank" href="https://github.com/wonglok/o3d-gen2">Github <img class="inline h-4 mx-1" src="../../Icons/extlink-white.svg" alt=""></a>
        </div>

        <div class="block lg:hidden">
          <svg @click="showMenu = !showMenu" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 18v1h-24v-1h24zm0-6v1h-24v-1h24zm0-6v1h-24v-1h24z" fill="white"/><path fill="white" d="M24 19h-24v-1h24v1zm0-6h-24v-1h24v1zm0-6h-24v-1h24v1z"/></svg>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="showMenu" class="absolute top-0 right-0 full bg-black-transp" @click="showMenu = false">
      </div>
    </transition>

    <transition name="slideinright">
      <div v-if="showMenu" class="absolute top-0 right-0 menu-panel overflow-scroll scrolling-touch">
        <div class="full p-3">
          <router-link class="block mx-3 my-5" to="/docs" exact-active-class="underline">Documentation</router-link>
          <router-link class="block mx-3 my-5" to="/demo" exact-active-class="underline">Demos</router-link>
          <a class="block mx-3 my-5" target="_blank" href="https://github.com/wonglok/o3d-gen2">Github <img class="inline h-4 mx-1" src="../../Icons/extlink.svg" alt=""></a>

          <div class="mt-3">
            <DocsLeftMenu @close="() => showMenu = false" :isMainArea="false"></DocsLeftMenu>
          </div>
          <div class="h-32"></div>
        </div>
      </div>
    </transition>
    <div v-if="showMenu" class="block lg:hidden absolute top-0 right-0 p-3">
      <img @click="showMenu = false" src="../../Icons/close.svg" alt="">
    </div>

  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  data () {
    return {
      showMenu: false
    }
  }
}
</script>

<style lang="postcss">
.bg-black-transp {
  background-color: rgba(0, 0, 0, 0.385);
}

.topnav {
  height: 56px;
  background-color: rgba(41, 41, 41, 0.856);
  border-bottom: rgb(5, 255, 67) solid 1px;
}

.menu-panel {
  background: white;
  width: 80%;
  height: 100%;
}

.slideinright-enter-active, .slideinright-leave-active {
  transition: transform .5s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}

.slideinright-enter, .slideinright-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>